interface Props {
  /** Imię proponującego; null = moja propozycja (można ją tylko wycofać). */
  by: string | null;
  text: string;
  /** Brak akcji = tylko informacja (np. zakończona lista, podsumowanie). */
  onAccept?: () => void;
  onReject?: () => void;
}

/** „Magda proponuje: Skyr naturalny” z decyzją robiącego zakupy. */
export function SuggestionBanner({ by, text, onAccept, onReject }: Props) {
  return (
    <div className="mt-1.5 mb-0.5 rounded-lg bg-sky-50 p-2 text-sky-950 dark:bg-sky-900/30 dark:text-sky-100">
      <p className="text-sm break-words">
        <span className="font-medium">{by === null ? 'Twoja propozycja:' : `${by} proponuje:`}</span> {text}
      </p>
      {by === null && onReject && (
        <button
          type="button"
          onClick={onReject}
          className="mt-1.5 min-h-11 w-full rounded-lg border border-sky-200 bg-white px-3 text-sm font-medium active:bg-sky-100 dark:border-sky-800 dark:bg-stone-900 dark:active:bg-stone-800"
        >
          Wycofaj propozycję
        </button>
      )}
      {by !== null && onAccept && onReject && (
        <div className="mt-1.5 flex gap-2">
          <button
            type="button"
            onClick={onAccept}
            className="min-h-11 flex-1 rounded-lg bg-brand-700 px-3 text-sm font-semibold text-white active:bg-brand-800"
          >
            Biorę
          </button>
          <button
            type="button"
            onClick={onReject}
            className="min-h-11 flex-1 rounded-lg border border-sky-200 bg-white px-3 text-sm font-medium active:bg-sky-100 dark:border-sky-800 dark:bg-stone-900 dark:active:bg-stone-800"
          >
            Nie ma
          </button>
        </div>
      )}
    </div>
  );
}
